<template>
  <div class="container" style="height: 100%">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <p class="title">{{ info.name }}</p>
        <p style="margin-top: 5px">
          <span class="time">{{
            formatDate(info.startTime, "MM-DD HH:mm")
          }}</span>
          <span class="count">已投：{{ doList.length }}/{{ list.length }}</span>
          <span class="shu">|</span>
          <span class="surplus" v-show="info.autoStop && info.status != 'STOP'"
            >剩余<i class="el-icon-time"></i>{{ surplus }}</span
          >
          <span class="end" v-show="info.status == 'STOP'">已结束</span>
        </p>
        <div class="right_btns">
          <el-button type="text">导出数据</el-button>
          <el-button
            type="text"
            v-show="info.status != 'STOP'"
            @click="handleStop"
            >结束活动</el-button
          >
        </div>
      </div>
    </div>
    <div class="main">
      <div
        class="row"
        v-for="item in newArr"
        :key="item.label"
        @click="
          show = !info.anonymous;
          showList = item.list;
        "
      >
        <p>{{ item.label }}</p>
        <el-progress
          :stroke-width="10"
          :percentage="parseInt(item.list.length / doList.length * 100) || 0"
          :format="(percentage) => format(percentage, item.list.length)"
        ></el-progress>
      </div>
    </div>

    <el-dialog class="list" :visible.sync="show" title="投票学生" width="50%">
      <el-table :data="showList">
        <el-table-column prop="avatar" label="头像" width="150" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 44px; height: 44px"
              :src="
                scope.row.avatar || require('@/assets/images/icons/icon_me.png')
              "
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="nickName"
          label="姓名"
          width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="createTime" label="投票时间" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime, "MM-DD HH:mm") }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import mixinsData from "../mixins/detail";
import { formatDate } from "@/utils/index";
import { voteList } from "@/api/assistantMode/activity/vote";
export default {
  name: "vote",
  mixins: [mixinsData],
  data() {
    return {
      formatDate,
      info: {},
      list: [],
      doList: [],
      notList: [],
      newArr: [],
      show: false,
      showList: [],
    };
  },
  watch: {
    info(val) {
      if (val.voteType == "RIGHT_ERROR") val.voteType = "正确_错误";
      else if (val.voteType == "AGREE_OPPOSE") val.voteType = "赞同_反对";
      let options = val.voteType.split("_");
      let arr = [];
      options.forEach((item) => {
        let one = this.doList.filter((t) => {
          return t.answer == item;
        });
        arr.push(one);
      });
      this.newArr = options.map((label, idx) => ({
        label,
        list: arr[idx],
      }));
    },
  },
  methods: {
    // 投票成员列表
    getList() {
      let activityId = this.$route.query.activityId;
      voteList({ activityId }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.doList = res.data.filter((item) => {
            return item.answer;
          });
          this.notList = res.data.filter((item) => {
            return !item.answer;
          });
        } else {
          console.log(res.msg);
        }
      });
    },
    format(percentage, num) {
      return `${num}人 ${parseInt(num / this.doList.length * 100) || 0}%`;
    },
  },
};
</script>
<style lang="less" scoped>
.top {
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
  .back_box {
    display: inline-block;
    width: calc(100% - 1126px);
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    img {
      width: 44px;
    }
    p {
      color: #969696;
      font-size: 16px;
    }
  }
  .info {
    position: relative;
    display: inline-block;
    padding: 24px 30px;
    background-color: #fff;
    width: 1126px;
    vertical-align: middle;
    .title {
      font-size: 16px;
      color: #333;
    }
    .time {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
    }

    .count {
      margin-left: 10px;
      color: #1890ff;
      font-size: 14px;
    }
    .shu {
      padding: 0 10px;
      color: #ddd;
    }
    .el-icon-time {
      margin: 0 5px;
    }
    .surplus {
      color: sandybrown;
    }
    .end {
      color: #999;
    }
    .right_btns {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
    }
  }
}
.main {
  padding: 20px 60px;
  height: calc(100% - 30px - 20px - 93px - 30px);
  background-color: #fff;
  ::v-deep .row {
    margin: 20px 0 40px;
    width: 400px;
    text-align: left;
    cursor: pointer;
    p {
      margin-bottom: 15px;
    }
    .el-progress-bar {
      width: 90%;
    }
  }
}

::v-deep .list {
  .is-leaf {
    color: #333;
    background-color: #f5f5f5;
  }
}
</style>